import { useState, useEffect } from 'react'
import {
  useMediaQuery,
  Container,
  Grid,
  TextField,
  FormControl,
  Select,
  IconButton,
  InputAdornment,
  makeStyles,
  useTheme,
} from '@material-ui/core'
import GpsFixedIcon from '@material-ui/icons/GpsFixed'
import Axios from 'axios'
import ButtonSp from '../../components/ui/ButtonSp'
import DropoffMap from '../../components/common/DropoffMap'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    flexGrow: 1,
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h1': {
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 24,
      ...theme.headerFont,
      lineHeight: 1.3,
      [theme.breakpoints.down('xs')]: {
        fontSize: 22,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.main,
      },
    },
  },
  fieldGrid: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  },
  mapWrapper: {
    width: '100%',
    ...theme.homeStyle.boxShadow,
    borderRadius: 10,
    margin: `${theme.spacing(1)}px 0 ${theme.spacing(0)}px 0`,
  },
  button: {
    
  },
  goToKerry: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 600,
    textAlign: 'center',
    fontSize: 32,
    color: '#828282',
    padding: theme.spacing(2),
    ...theme.headerFont,
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  goToKerryLogoLine: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  kerryLogo: {
    width: 350,
    margin: `0 ${theme.spacing(2)}px`,
    verticalAlign: 'middle',
    [theme.breakpoints.down('xs')]: {
      width: 300,
    },
  },
  kerryBtn: {
    padding: theme.spacing(2),
    backgroundColor: '#F37325 !important',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0.5),
    },
  },
  kerryBtnWrapper: {
    margin: theme.spacing(2),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    }
  },
  kerryBtnLabel: {
    fontSize: 22,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
}))

const DropoffPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const classes = useStyles()

  const { t } = useTranslation('dropoff')

  const [userLocation, setUserLocation] = useState(null)
  const [isUserLocationShow, setUserLocationShow] = useState(false)
  const [dropoffData, setDropoffData] = useState([])
  const [courier, setCourier] = useState('thp')
  const [isMapLoading, setMapLoading] = useState(true)
  const [searchKeyword, setSearchKeyword] = useState('')

  const updateUserLocation = () => {
    // v these console log is commented so that if there are someone going to debug this is future, they can un comment these
    // console.log('started getting geolocation')
    if (typeof navigator !== 'undefined' && 'geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // console.log('Latitude is :', position.coords.latitude)
          // console.log('Longitude is :', position.coords.longitude)
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
          setUserLocationShow(true)
        },
        (error) => {
          if (error.code == error.PERMISSION_DENIED) {
            // console.log('can not access user location: using Shippop HQ location')
            setUserLocation({ lat: 13.7563802, lng: 100.5324896 })
          } else {
            // console.log(error)
            setUserLocation({ lat: 13.7563802, lng: 100.5324896 })
          }
        }
      )
    } else {
      // console.log('geolocation is not found')
    }
  }

  useEffect(() => {
    // on render get user location
    updateUserLocation()
  }, [])

  const courierSelectToCourierPath = (courierSelectValue) => {
    switch(courierSelectValue) {
      case 'thp':
        return 'thaipost'
      case 'jte':
        return 'jte'
      case 'popshop':
        return 'popshop'
      case 'thp_inter':
        return 'thp_inter'
      default:
        return ''
    }
  }

  const searchForNearby = () => {
    setMapLoading(true)
    if (userLocation !== null) {
      const tempLoc = userLocation
      // console.log('start api for', tempLoc)
      Axios.post(`/api/dropoff/${courierSelectToCourierPath(courier)}/nearby`, {
        latitude: userLocation.lat,
        longitude: userLocation.lng,
      })
        .then((res) => {
          // console.log('finish api for', tempLoc)
          setDropoffData(res.data.data)
          setMapLoading(false)
        })
        .catch((err) => {
          // console.log(err)
          setMapLoading(false)
        })
    }
  }

  const searchForKeyword = () => {
    // console.log('starting api for keyword:', searchKeyword)
    Axios.post(`/api/dropoff/${courierSelectToCourierPath(courier)}/search`, {
      qurey: searchKeyword,
    })
      .then((res) => {
        // console.log('finish api for keyword ', searchKeyword)
        setDropoffData(res.data.data)
        setMapLoading(false)
      })
      .catch((err) => {
        // console.log(err)
        setMapLoading(false)
      })
  }

  useEffect(() => {
    // on userlocation change (after finish get user location) query
    searchForNearby()
  }, [userLocation])

  useEffect(() => {
    // when change courier, automatically show nearby
    if (courier !== 'kerry') searchForNearby()
  },[courier])

  const renderGoToKerry = () => {
    return (
      <div className={classes.goToKerry}>
        <div className={classes.goToKerryLogoLine}>
          {t('you-can-find-kerry-1')}
          <img
            src="/static/img/couriers/kerry2.png"
            alt="Kerry Express"
            className={classes.kerryLogo}
          />
          {t('you-can-find-kerry-2')}
        </div>
        {t('you-can-find-kerry-3')}
        <a href="https://th.kerryexpress.com/th/where-we-are/" target="_blank" className={classes.kerryBtnWrapper}>
        <ButtonSp
          variant="contained"
          className={classes.kerryBtn}
          fullWidth
        >
          <span className={classes.kerryBtnLabel}>
            {t('find-branches')}{' '}
            {isMobile && <br />}
            Kerry Express {'>'}
          </span>
        </ButtonSp>
        </a>
      </div>
    )
  }

  const renderCourierSelect = () => {
    return (
      <FormControl variant="outlined" fullWidth size="small">
        <Select
          id="select-courier"
          value={courier}
          onChange={(e) => setCourier(e.target.value)}
          native
        >
          <option value="thp">{t('thai-post')}</option>
          <option value="thp_inter">{t('thai-post-inter')}</option>
          <option value="jte">{'J&T Express'}</option>
          <option value="kerry">{'Kerry Express'}</option>
          <option value="popshop">{'POP SHIPPOP'}</option>
        </Select>
      </FormControl>
    )
  }

  return (
    <div className={classes.root}>
        <div className={classes.page}>
          <Container className={classes.pageContainer}>
            <h1>{t('page-title')}</h1>
            <Grid container>
              <Grid item xs={12} sm={3} className={classes.fieldGrid}>
                {renderCourierSelect()}
              </Grid>
              <Grid item xs={12} sm={7} className={classes.fieldGrid}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label={isMobile ? t('search-by-short') : t('search-by')}
                  disabled={courier === 'kerry'}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            if (!isUserLocationShow) {
                              alert(t('please-enable-location'))
                            } else {
                              searchForNearby()
                            }
                          }}
                          disabled={courier === 'kerry'}
                        >
                          <GpsFixedIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      searchForKeyword()
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2} className={classes.fieldGrid}>
                <ButtonSp
                  fullWidth
                  className={classes.button}
                  onClick={() => {
                    searchForKeyword()
                  }}
                  disabled={courier === 'kerry'}
                >
                  {t('search')}
                </ButtonSp>
              </Grid>
            </Grid>
            <div className={classes.mapWrapper}>
              {courier === 'kerry' ? (
                renderGoToKerry()
              ) : (
                <DropoffMap
                  locationsData={dropoffData}
                  userLocation={userLocation}
                  showUserLocation={isUserLocationShow}
                  height={isMobile ? 300 : 600}
                  isLoading={isMapLoading}
                  isEmbed
                />
              )}
            </div>
          </Container>
        </div>
    </div>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['common','header','footer','pdpa','dropoff'])
  }
})

export default DropoffPage
